import React from 'react';
import { CrewCertificate } from '../../types';

interface DocumentStatusColumnProps {
  certificate: CrewCertificate;
  employees: any[];
  today: Date;
}

const DocumentStatusColumn: React.FC<DocumentStatusColumnProps> = ({ certificate, employees, today }) => {
  const employee = employees.find((e: any) => e.id === certificate.employeeId!);
  const docs = employee?.documents || [];

  const expiredCount = docs.filter((doc: any) => doc.status === 'expired').length;
  const expiring3MonthsCount = docs.filter((doc: any) => {
    if (doc.status !== 'valid') return false;
    const expiryDate = new Date(doc.expiryDate);
    const threeMonthsFromNow = new Date();
    threeMonthsFromNow.setMonth(today.getMonth() + 3);
    return expiryDate <= threeMonthsFromNow;
  }).length;
  const expiring6MonthsCount = docs.filter((doc: any) => {
    if (doc.status !== 'valid') return false;
    const expiryDate = new Date(doc.expiryDate);
    const sixMonthsFromNow = new Date();
    sixMonthsFromNow.setMonth(today.getMonth() + 6);
    const threeMonthsFromNow = new Date();
    threeMonthsFromNow.setMonth(today.getMonth() + 3);
    return expiryDate <= sixMonthsFromNow && expiryDate > threeMonthsFromNow;
  }).length;
  const validCount = docs.filter((doc: any) => {
    if (doc.status !== 'valid') return false;
    const expiryDate = new Date(doc.expiryDate);
    const sixMonthsFromNow = new Date();
    sixMonthsFromNow.setMonth(today.getMonth() + 6);
    return expiryDate > sixMonthsFromNow;
  }).length;

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap gap-2">
        <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
          Valid: {validCount}
        </div>
        {expiring3MonthsCount > 0 && (
          <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
            Expiring 3M: {expiring3MonthsCount}
          </div>
        )}
        {expiring6MonthsCount > 0 && (
          <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
            Expiring 6M: {expiring6MonthsCount}
          </div>
        )}
        {expiredCount > 0 && (
          <div className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
            Expired: {expiredCount}
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentStatusColumn;
